import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
// import { CalculatorsModule } from '@app/calculators/calculators.module';

@Component({
  selector: 'app-payload-debug',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    // CalculatorsModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './payload-debug.component.html',
})
export class PayloadDebugComponent implements OnInit {
  private _router = inject(Router);
  private dialogRef = inject(MatDialogRef<PayloadDebugComponent>);
  private cdr = inject(ChangeDetectorRef);

  error: any = {
    status: false,
    message: '',
    info: '',
  };

  ngOnInit(): void {
    this.cdr.detectChanges();
  }

  onSubmit(e: any) {
    const file = e.target.files[0];
    this.readFile(file);
  }

  private readFile(file: File): void {
    this.error = {
      status: false,
      message: '',
      info: '',
    };
    const fileReader = new FileReader();

    fileReader.onload = (event: any) => {
      try {
        sessionStorage.removeItem('debugState');
        const rawPayload = event.target.result as string;
        const parsedPayload = JSON.parse(rawPayload);
        console.warn('parsedPayload', parsedPayload);

        const withdrawalProductType = parsedPayload.metaData.withdrawalProductType;
        sessionStorage.setItem('debugState', JSON.stringify(parsedPayload));
        const task = parsedPayload.metaData.tasks;

        const state = {
          withdrawalProductType,
          task,
          payload: parsedPayload,
        };

        this.handleRoute(state);
      } catch (error) {
        console.error('Error parsing JSON file:', error);
        this.error = {
          status: true,
          message: 'Error parsing the JSON object',
          info: error,
        };
        this.cdr.detectChanges();
      }
    };

    fileReader.onerror = (event: any) => {};

    fileReader.readAsText(file);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  handleRoute(state: any) {
    const routeMap: { [key: string]: string } = {
      REBUILD_COSTS: '/rebuild-form/debug',
      BUILDING_COSTS_AND_DATES: '/process-form/debug',
      OPERATING_COSTS: '/operational-form/debug',
      LCC: '/lcc-form/debug',
      BUILDING_INSURANCE_VALUES: '/insurance-form/debug',
      INSURANCE_VALUES_GVBS: '/gvbs/debug',
      SMALL_BUILDING_AGV: '/agv-small-building-form/debug',
      DAMAGE_COSTS: '/damage-form/debug',
      KV_BIM: '/kv-to-bim/debug',
      LCA: '/lca-form/debug',
    };

    if (state.withdrawalProductType === 'LCA') {
      const _kvbimTasks = ['BUILDING_COSTS_AND_DATES', 'LCA', 'BIM_EVALUATION'].every((t) => state.task.includes(t));
      const lcaRoute = _kvbimTasks ? routeMap['KV_BIM'] : routeMap['LCA'];
      this._router.navigate([lcaRoute], { state });
    } else if (routeMap[state.withdrawalProductType]) {
      this._router.navigate([routeMap[state.withdrawalProductType]], { state });
    }

    this.closeDialog();
  }
}
